import { modalRenderer } from '~/modal/modalRendererRegistry';
import { SubscriptionManagementUnavailableModalComponent } from './subscriptionManagementUnavailableModal.component';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    SubscriptionManagementUnavailable: undefined;
  }
}

modalRenderer.register('SubscriptionManagementUnavailable', SubscriptionManagementUnavailableModalComponent);
